import { render, staticRenderFns } from "./approval-inventory-adjectment.vue?vue&type=template&id=e99bcd4e&scoped=true"
import script from "./approval-inventory-adjectment.vue?vue&type=script&lang=js"
export * from "./approval-inventory-adjectment.vue?vue&type=script&lang=js"
import style0 from "./approval-inventory-adjectment.vue?vue&type=style&index=0&id=e99bcd4e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e99bcd4e",
  null
  
)

export default component.exports